/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum PositionRole {
  TeamLead = "Team Lead",
  TeamSecondment = "Team Secondment",
  IndividualSecondment = "Individual Secondment",
  Counsel = "Counsel",
  Other = "Other",
}

export const PositionRoleDisplay: Record<PositionRole, string> = {
  [PositionRole.TeamLead]: "Team Lead",
  [PositionRole.TeamSecondment]: "Team Secondment",
  [PositionRole.IndividualSecondment]: "Individual Secondment",
  [PositionRole.Counsel]: "Counsel",
  [PositionRole.Other]: "Other",
};
